<template>
  <custom-btn-icon
    @click="onClick"
    :btn-text="paused ? 'Reprendre' : 'Prendre'"
    :loading="loading"
    :disabled="loading"
    color="primary"
    icon="mdi-account-lock"
  />
</template>

<script>
import CustomBtnIcon from '@/components/displays/CustomBtnIcon';
import {
  selfAssign,
  selfUnassign,
} from '@/services/api/internal/requestActions/selfAssign.api';
import { mapGetters } from 'vuex';
import { catchCRUDError } from '@/business/apiTreatment/response/errorTreatment';

export default {
  name: 'SelfAssign',
  components: {
    CustomBtnIcon,
  },
  props: {
    requestId: {
      type: Number,
      required: true,
    },
    assigned: {
      type: Boolean,
      required: false,
    },
    paused: {
      type: Boolean,
      required: false,
      default: false,
    },
    groupId: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      active: 'requests/active',
      myGroupId: 'global/groupId',
    }),
  },
  data() {
    return {
      clicked: false,
      loading: false,
    };
  },
  methods: {
    selfAssign,
    selfUnassign,
    onClick() {
      this.clicked = true;
      this.loading = true;
      if (this.paused) {
        this.selfUnassign(this.requestId, {
          group_id: this.groupId,
          is_dispatched: 'O',
        })
          .then((response) => {
            if (response.status === 200)
              this.$emit('success', response.data.message);
            this.$store.dispatch('requests/refreshItems');
            this.$store.dispatch('requests/removeCurrent', this.requestId);
            this.$store.dispatch('boilerplate/setModalClosed');
          })
          .catch((err) => {
            this.$store.dispatch(
              'snackbar/setSnackbarOpen',
              catchCRUDError('FREE', err)
            );
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.selfAssign(this.requestId, { group_id: this.myGroupId })
          .then(() => {
            this.$store.dispatch('requests/removeItem', this.requestId);
            this.$store.dispatch('requests/dispatched/refreshItems');
            if (this.active)
              this.$store.dispatch('requests/refreshCurrent', this.requestId);
            this.$store.dispatch(`requests/logs/setUrlParamId`, this.requestId);
          })
          .catch((err) => {
            this.$store.dispatch(
              'snackbar/setSnackbarOpen',
              catchCRUDError('TAKE', err)
            );
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
